import React from "react";

let CheckOutView = (props) => {

    let {run, pickup, onLocationCheckin, enableEdit} = props;

    if(pickup.isCheckOut && run.isBaseCheckedIn && !run.isBaseCheckedOut && run.isAllNonBaseComplete && enableEdit){
        return (
            <div className="row mt-1">
                <div className="col-12 text-right">
                    <button type="button" className="btn btn-primary" onClick={onLocationCheckin}>Check-out</button>
                </div>
            </div>);
    } else {
        return null;
    }
};

export default CheckOutView;